<script setup>
import { computed } from 'vue'

const props = defineProps({
    message: {
        type: String,
    },
    type: {
        type: String,
    },
});

const _message = computed(() => {
    if (props.message) {
        return props.message
    }

    switch (props.type) {
        case 'projects':
            return 'No Projects Found !'
        case 'documents':
            return 'No Documents Found !'
        default:
            return "No Result Found !"
    }
})
</script>

<template>
    <div class="row">
        <div class="col text-center">

            <svg v-if="type === 'projects'"
                width="215"
                height="172"
                viewBox="0 0 215 172"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect width="215"
                    height="172"
                    fill="white" />
                <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M54.1801 115.24H132.44C132.883 115.24 133.315 115.192 133.73 115.102C134.146 115.192 134.577 115.24 135.02 115.24H179.74C183.065 115.24 185.76 112.545 185.76 109.22C185.76 105.895 183.065 103.2 179.74 103.2H174.58C171.255 103.2 168.56 100.505 168.56 97.18C168.56 93.8553 171.255 91.16 174.58 91.16H190.92C194.245 91.16 196.94 88.4648 196.94 85.14C196.94 81.8153 194.245 79.12 190.92 79.12H172C175.325 79.12 178.02 76.4248 178.02 73.1C178.02 69.7753 175.325 67.08 172 67.08H116.96C120.285 67.08 122.98 64.3848 122.98 61.06C122.98 57.7353 120.285 55.04 116.96 55.04H67.9401C64.6154 55.04 61.9201 57.7353 61.9201 61.06C61.9201 64.3848 64.6154 67.08 67.9401 67.08H33.5401C30.2154 67.08 27.5201 69.7753 27.5201 73.1C27.5201 76.4248 30.2154 79.12 33.5401 79.12H55.0401C58.3649 79.12 61.0601 81.8153 61.0601 85.14C61.0601 88.4648 58.3649 91.16 55.0401 91.16H20.6401C17.3154 91.16 14.6201 93.8553 14.6201 97.18C14.6201 100.505 17.3154 103.2 20.6401 103.2H54.1801C50.8554 103.2 48.1601 105.895 48.1601 109.22C48.1601 112.545 50.8554 115.24 54.1801 115.24ZM194.36 115.24C197.685 115.24 200.38 112.545 200.38 109.22C200.38 105.895 197.685 103.2 194.36 103.2C191.035 103.2 188.34 105.895 188.34 109.22C188.34 112.545 191.035 115.24 194.36 115.24Z"
                    fill="#EFECFF" />
                <g clip-path="url(#clip0_1110_34043)">
                    <path
                        d="M146.959 122.21H66.197C64.4928 122.21 63.1738 120.802 63.1738 119.186V52.8105C63.1738 51.8951 63.9344 51.0693 64.915 51.0693H98.5303C99.0436 51.0693 99.6307 51.3655 99.9934 51.9797L102.383 56.7583C103.048 58.2663 104.54 59.0458 106.079 59.0458H146.959C147.94 59.0458 148.7 59.8716 148.7 60.787V120.468C148.7 121.449 147.874 122.21 146.959 122.21Z"
                        fill="#EFECFF"
                        stroke="#5E45FF"
                        stroke-width="2.5" />
                    <path d="M148.47 60.8018H65.002V90.8561H148.47V60.8018Z"
                        fill="white" />
                    <path d="M66.1415 59.8018H65.002V89.8561H66.1415V59.8018Z"
                        fill="#EFECFF" />
                    <path
                        d="M153.084 66.9128V117.905C153.084 120.327 151.232 122.179 148.811 122.179H66.197C63.7755 122.179 61.9238 120.327 61.9238 117.905V73.7498C61.9238 71.3283 63.7755 69.4766 66.197 69.4766H107.789C108.928 69.4766 110.068 69.0493 110.78 68.1947L115.053 63.9216C115.908 63.067 116.905 62.6396 118.044 62.6396H148.811C151.232 62.6396 153.084 64.6338 153.084 66.9128Z"
                        fill="#EFECFF" />
                    <path
                        d="M151.834 68.194V119.187C151.834 120.918 150.542 122.21 148.811 122.21H66.197C64.4659 122.21 63.1738 120.918 63.1738 119.187V75.031C63.1738 73.2999 64.4659 72.0079 66.197 72.0079H107.789C109.192 72.0079 110.699 71.4911 111.701 70.3231L115.937 66.0867C116.573 65.4507 117.258 65.1709 118.044 65.1709H148.811C150.515 65.1709 151.834 66.5781 151.834 68.194Z"
                        stroke="#5E45FF"
                        stroke-width="2.5" />
                </g>
                <defs>
                    <clipPath id="clip0_1110_34043">
                        <rect width="91.16"
                            height="91.16"
                            fill="white"
                            transform="translate(61.9238 40.4189)" />
                    </clipPath>
                </defs>
            </svg>

            <svg v-else-if="type === 'documents'"
                width="251"
                height="200"
                viewBox="0 0 251 200"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M207.5 65C211.366 65 214.5 68.134 214.5 72C214.5 75.866 211.366 79 207.5 79H167.5C171.366 79 174.5 82.134 174.5 86C174.5 89.866 171.366 93 167.5 93H189.5C193.366 93 196.5 96.134 196.5 100C196.5 103.866 193.366 107 189.5 107H179.326C174.452 107 170.5 110.134 170.5 114C170.5 116.577 172.5 118.911 176.5 121C180.366 121 183.5 124.134 183.5 128C183.5 131.866 180.366 135 176.5 135H93.5C89.634 135 86.5 131.866 86.5 128C86.5 124.134 89.634 121 93.5 121H54.5C50.634 121 47.5 117.866 47.5 114C47.5 110.134 50.634 107 54.5 107H94.5C98.366 107 101.5 103.866 101.5 100C101.5 96.134 98.366 93 94.5 93H69.5C65.634 93 62.5 89.866 62.5 86C62.5 82.134 65.634 79 69.5 79H109.5C105.634 79 102.5 75.866 102.5 72C102.5 68.134 105.634 65 109.5 65H207.5ZM207.5 93C211.366 93 214.5 96.134 214.5 100C214.5 103.866 211.366 107 207.5 107C203.634 107 200.5 103.866 200.5 100C200.5 96.134 203.634 93 207.5 93Z"
                    fill="#EFECFF" />
                <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M154.173 63.9997L163.475 131.842L164.311 138.649C164.58 140.841 163.021 142.837 160.828 143.106L102.268 150.297C100.075 150.566 98.0795 149.007 97.8103 146.814L88.7945 73.3865C88.6599 72.2901 89.4395 71.2922 90.5359 71.1576C90.5428 71.1568 90.5497 71.156 90.5567 71.1552L95.415 70.6102M99.3431 70.1696L103.93 69.655L99.3431 70.1696Z"
                    fill="white" />
                <path
                    d="M155.412 63.8299C155.318 63.1459 154.687 62.6675 154.003 62.7613C153.32 62.8551 152.841 63.4855 152.935 64.1695L155.412 63.8299ZM163.475 131.842L164.716 131.69C164.715 131.684 164.714 131.678 164.714 131.673L163.475 131.842ZM164.311 138.649L165.552 138.496L164.311 138.649ZM160.828 143.106L160.981 144.347L160.828 143.106ZM102.268 150.297L102.42 151.537L102.268 150.297ZM97.8103 146.814L99.051 146.662L97.8103 146.814ZM88.7945 73.3865L87.5538 73.5388L88.7945 73.3865ZM90.5567 71.1552L90.696 72.3974L90.5567 71.1552ZM95.5544 71.8524C96.2404 71.7755 96.7342 71.1569 96.6572 70.4709C96.5803 69.7848 95.9617 69.291 95.2757 69.368L95.5544 71.8524ZM99.2038 68.9274C98.5178 69.0043 98.024 69.6229 98.1009 70.3089C98.1779 70.995 98.7964 71.4887 99.4825 71.4118L99.2038 68.9274ZM104.07 70.8972C104.756 70.8203 105.249 70.2017 105.172 69.5157C105.095 68.8296 104.477 68.3359 103.791 68.4128L104.07 70.8972ZM152.935 64.1695L162.237 132.012L164.714 131.673L155.412 63.8299L152.935 64.1695ZM162.234 131.995L163.07 138.801L165.552 138.496L164.716 131.69L162.234 131.995ZM163.07 138.801C163.255 140.309 162.183 141.681 160.676 141.866L160.981 144.347C163.858 143.994 165.905 141.374 165.552 138.496L163.07 138.801ZM160.676 141.866L102.116 149.056L102.42 151.537L160.981 144.347L160.676 141.866ZM102.116 149.056C100.608 149.241 99.2361 148.169 99.051 146.662L96.5696 146.966C96.923 149.844 99.5424 151.891 102.42 151.537L102.116 149.056ZM99.051 146.662L90.0352 73.2341L87.5538 73.5388L96.5696 146.966L99.051 146.662ZM90.0352 73.2341C89.9847 72.823 90.2771 72.4488 90.6882 72.3983L90.3835 69.9169C88.602 70.1357 87.3351 71.7572 87.5538 73.5388L90.0352 73.2341ZM90.6882 72.3983C90.6908 72.398 90.6934 72.3977 90.696 72.3974L90.4173 69.913C90.4061 69.9142 90.3948 69.9156 90.3835 69.9169L90.6882 72.3983ZM90.696 72.3974L95.5544 71.8524L95.2757 69.368L90.4173 69.913L90.696 72.3974ZM99.4825 71.4118L104.07 70.8972L103.791 68.4128L99.2038 68.9274L99.4825 71.4118Z"
                    fill="#5E45FF" />
                <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M151.641 68.2696L160.06 129.753L160.818 135.922C161.062 137.909 159.668 139.715 157.704 139.956L105.262 146.395C103.298 146.636 101.509 145.221 101.265 143.234L93.1148 76.8572C92.9802 75.7608 93.7598 74.7629 94.8562 74.6283L101.344 73.8318"
                    fill="#EFECFF" />
                <path
                    d="M108.422 54C108.422 52.4812 109.653 51.25 111.172 51.25H156.729C157.458 51.25 158.157 51.5395 158.673 52.0549L172.116 65.4898C172.632 66.0056 172.922 66.7053 172.922 67.4349V130C172.922 131.519 171.691 132.75 170.172 132.75H111.172C109.653 132.75 108.422 131.519 108.422 130V54Z"
                    fill="white"
                    stroke="#5E45FF"
                    stroke-width="2.5" />
                <path d="M157.172 52.4023V63.9995C157.172 65.6564 158.515 66.9995 160.172 66.9995H168.105"
                    stroke="#5E45FF"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M118.5 118H144.5M118.5 67H144.5H118.5ZM118.5 79H161.5H118.5ZM118.5 92H161.5H118.5ZM118.5 105H161.5H118.5Z"
                    stroke="#5E45FF"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>

            <h4>
                <!-- No Documents Found ! -->
                {{ _message }}
            </h4>

        </div>
    </div>
</template>
